import * as Sentry from '@sentry/react'

export function captureException(err) {
  Sentry.configureScope(scope => {
    if (localStorage.user) {
      try {
        if (localStorage.user && localStorage.user !== '') {
          const user = JSON.parse(localStorage.user)
          scope.setUser({
            id: user.id,
            email: user.email
          })
        }
      } catch (e) {}
    }
  })

  return Sentry.captureException(err)
}
